import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiResponse } from 'src/app/model/apiResponse.model';
import { ApiProviderService } from 'src/app/services/api-provider.service';

@Injectable({
  providedIn: 'root'
})
export class SsoService {

  headers: HttpHeaders;
  apiServer: string;

  constructor(private http: HttpClient, private apiRef: ApiProviderService) {
    this.headers = new HttpHeaders();
    this.headers.append('Content-Type', 'application/json');
    this.headers.append('Accept', 'application/json');
    this.apiServer = 'api/sso/';
  }

  cacheRedirectUrl(returnUrl: string): Observable<boolean> {
    return this.http.post<ApiResponse>(this.apiRef.getApiUrl(`${this.apiServer}storeRedirect`), {Uri: returnUrl},
      { headers: this.headers })
      .pipe(map(json => json.result as boolean));
  }
}
